import React, { PropTypes } from 'react'
import { translate } from 'react-i18next'
import ErrorModal from '../../../components/Modal/ErrorModal'

const SignupError = props => {
  const { t, errorMessage, router } = props

  return (
    <ErrorModal
      visible
      closeAction={() => router.push('/landing')}
      backAction={router.goBack}
      header={t('Error')}
      message={errorMessage}
    />
  )
}

SignupError.propTypes = {
  errorMessage: PropTypes.string,
  t: PropTypes.func,
  router: PropTypes.object
}

export default translate([ 'common', 'landing', 'forms' ], { wait: true })(
  SignupError
)



// WEBPACK FOOTER //
// ./src/pages/Landing/Onboarding/SignupError.js